import {createReducer} from '@reduxjs/toolkit'
import {changeEventAction} from '../actions/event'
import {ScheduleState} from '../types/state'

const defaultState = {
  facets: {},
  items: [],
  limit: 0,
  offset: 0,
  total: 0,
} as ScheduleState

export const schedule = createReducer(defaultState, builder => {
  builder.addCase(changeEventAction, (_, action) => {
    return action.payload.schedule
  })
})
